import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ON_CLICK } from '../constants';
const getClickWrapperOptions = (children = {}, componentProps = {}, id = null) => {
  let shouldUseClickWrapper = false;
  const {
    props: {
      children: childComponents = []
    } = {}
  } = children || {};
  if (!childComponents || !childComponents[1]) return {
    shouldUseClickWrapper,
    wrapperProps: {}
  };
  const clickEvents = childComponents[1].map(child => {
    const {
      props: {
        component: {
          settings: {
            gtmEvents
          } = {}
        } = {}
      } = {}
    } = child || {};
    if (!gtmEvents) return null;
    return gtmEvents.find(({
      eventTrigger
    }) => eventTrigger === ON_CLICK);
  }).filter(Boolean);
  shouldUseClickWrapper = !!clickEvents && !!clickEvents.length;
  const wrapperProps = shouldUseClickWrapper ? _objectSpread(_objectSpread({
    gtmChildren: children
  }, componentProps), {}, {
    id
  }) : {};
  return {
    shouldUseClickWrapper,
    wrapperProps
  };
};
export default getClickWrapperOptions;
//# sourceMappingURL=get-click-wrapper-options.js.map